/**
 *  echarts tooltip 自动轮播
 *  @author liuwei
 *  @param myChart  //初始化echarts的实例
 *  @param option   //指定图表的配置项和数据
 *  @param num      //类目数量(原因：循环时达到最大值后，使其从头开始循环)
 *  @param seriesIndex //循环的数据的数组索引seriesIndex
 *  @param time     //轮播间隔时长
 */
export function autoHover(myChart, option, seriesIndex, num, time, timerName) {
    // console.log('num',num);
    var defaultData = {   //设置默认值
        time: 2000,
        num: 100
    };
    if (!time) {
        time = defaultData.time;
    }
    if (!num) {
        num = defaultData.num + 2;
    }
    var count = 0;
    var timeTicket = null;
    let storage = window.sessionStorage.getItem(timerName) || '';
    if (storage != '') {
        count = 0;
        clearInterval(storage);
    }
    timeTicket = setInterval(function () {
        myChart.dispatchAction({
            type: "downplay",
            seriesIndex: seriesIndex //serieIndex的索引值   可以触发多个
        });
        myChart.dispatchAction({
            type: "highlight",
            seriesIndex: seriesIndex,
            dataIndex: count
        });
        myChart.dispatchAction({
            type: "showTip",
            seriesIndex: seriesIndex,
            dataIndex: count
        });
        count++;
        if (count >= num) {
            count = 0
        }
    }, time);
    window.sessionStorage.setItem(timerName, timeTicket);
    myChart.on("mouseover", function (params) {
        clearInterval(timeTicket);
        myChart.dispatchAction({
            type: "downplay",
            seriesIndex: seriesIndex
        });
        myChart.dispatchAction({
            type: "highlight",
            seriesIndex: seriesIndex,
            dataIndex: params.dataIndex
        });
        myChart.dispatchAction({
            type: "showTip",
            seriesIndex: seriesIndex,
            dataIndex: params.dataIndex
        });
    });

    myChart.on("mouseout", function () {
        timeTicket && clearInterval(timeTicket);
        timeTicket = setInterval(function () {
            myChart.dispatchAction({
                type: "downplay",
                seriesIndex: seriesIndex //serieIndex的索引值   可以触发多个
            });
            myChart.dispatchAction({
                type: "highlight",
                seriesIndex: seriesIndex,
                dataIndex: count
            });
            myChart.dispatchAction({
                type: "showTip",
                seriesIndex: seriesIndex,
                dataIndex: count
            });
            count++;
            if (count >= 17) {
                count = 0
            }
        }, 3000);
    });
}
export default {
    autoHover
}


//////////////////
// WEBPACK FOOTER
// ./static/js/tools.js
// module id = null
// module chunks = 